const badgeTypes = ['original', 'long'] as const;
export type BadgeType = typeof badgeTypes[number];

export const isBadgeType = (input: string): input is BadgeType => {
    return badgeTypes.includes(input as BadgeType);
};